import { z } from "zod";
import { memberIdSchema, parameterValueSchema } from "./common.schemas";
import { newCanonicalSchema } from "./entity-id.schemas";

const deviceParameterSchema = z.object({
  id: memberIdSchema.optional(),
  label: z.string().trim().min(1),
  value: parameterValueSchema,
});

/**
 * A device kind's revisable content. `manufacturer` and `modelNumber` are NOT
 * here: the domain sets them at construction and exposes no setter, so a
 * revision that accepted them would drop them silently. They live on `define`
 * alone, and `copyForRevision` carries them across every later revision.
 */
const deviceDefinitionContentSchema = z.object({
  parameters: z.array(deviceParameterSchema),
});

export const defineDeviceDefinitionInputSchema = deviceDefinitionContentSchema.extend({
  definitionUrl: newCanonicalSchema,
  name: z.string().trim().min(1),
  description: z.string().trim().min(1).optional(),
  manufacturer: z.string().trim().min(1).optional(),
  modelNumber: z.string().trim().min(1).optional(),
});
export type DefineDeviceDefinitionInput = z.infer<typeof defineDeviceDefinitionInputSchema>;

export const reviseDeviceDefinitionInputSchema = deviceDefinitionContentSchema.extend({
  definitionUrl: z.string().url(),
  expectedVersion: z.number().int().positive(),
});
export type ReviseDeviceDefinitionInput = z.infer<typeof reviseDeviceDefinitionInputSchema>;

export const correctDeviceDefinitionInputSchema = z.object({
  definitionUrl: z.string().url(),
  name: z.string().trim().min(1).optional(),
  description: z.string().trim().min(1).nullable().optional(),
});
export type CorrectDeviceDefinitionInput = z.infer<typeof correctDeviceDefinitionInputSchema>;

export const changeDeviceDefinitionAvailabilityInputSchema = z.object({
  definitionUrl: z.string().url(),
});
export type ChangeDeviceDefinitionAvailabilityInput = z.infer<typeof changeDeviceDefinitionAvailabilityInputSchema>;
